import { cardStringParser } from '../../../../types/cardTypes';
import { isSeatIndex } from '../../../../types/pokerTypes';
import { playerVisibilityOrdinalParser } from '../../commonInbounds/utils/genericPlayerInboundUtils';
import { playerAvatarParser } from '../../commonInbounds/utils/playerAvatarInboundUtils';
import { parseInboundPayload } from '../../inbound';
import { booleanParser, encodedStringParser, numberArrayParser, numberParser, stringParser } from '../../inboundParsers';
import { splitWithBraces, trimBraces } from '../../inboundUtils';
import { playerMedalsParser } from './medalInboundUtils';
/**
 * Unlike holeCardsParser, a player's revealed (showdown) cards could be an array of empty strings.
 * In this case, each card will be undefined but I think we want to still create the array to know how many card backs to render.
 */
export function revealedCardsParser(str) {
    return trimBraces(str)
        .split(',')
        .map((cardStr) => (cardStr ? cardStringParser(cardStr) : undefined));
}
function communityCardWithIndexParser(str) {
    const parts = trimBraces(str).split(',');
    const index = Number(parts[0]);
    const card = cardStringParser(parts[1]);
    return { index, card, cardEmphasis: 'normal' };
}
export function communityCardsWithIndexesParser(str) {
    const communityCardsStrings = splitWithBraces(trimBraces(str));
    if (!communityCardsStrings[0].length) {
        return [];
    }
    return communityCardsStrings.map(communityCardWithIndexParser);
}
const inboundPokerPlayerPartDefinitions = [
    { name: 'sessionId', parser: stringParser },
    { name: 'isClientLoadDone', parser: booleanParser },
    { name: 'id', parser: numberParser },
    { name: 'name', parser: stringParser },
    { name: 'numChips', parser: numberParser },
    { name: 'numChipsInBank', parser: numberParser },
    { name: 'level', parser: numberParser },
    { name: 'score', parser: numberParser },
    { name: 'seatIndex', parser: optionalSeatIndexParser },
    { name: 'isIn', parser: booleanParser },
    { name: 'isSittingOut', parser: booleanParser },
    { name: 'isConnected', parser: booleanParser },
    { name: 'avatar', parser: playerAvatarParser },
    { name: 'numBuyins', parser: numberParser },
    { name: 'typeHtml', parser: encodedStringParser }, // TODO
    { name: 'playerStyleString', parser: stringParser }, // TODO
    { name: 'flagId', parser: numberParser },
    { name: 'flagUrl', parser: stringParser },
    { name: 'playerVisibility', parser: playerVisibilityOrdinalParser },
    { name: 'isAdmin', parser: booleanParser },
    { name: 'isHelper', parser: booleanParser },
    { name: 'isSecretAdmin', parser: booleanParser },
    { name: 'isPowerPlayer', parser: booleanParser },
    { name: 'medals', parser: playerMedalsParser }
];
export function inboundPokerPlayerParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, inboundPokerPlayerPartDefinitions);
}
export function optionalSeatIndexParser(str) {
    const seatIndexNum = numberParser(str);
    if (isSeatIndex(seatIndexNum)) {
        return seatIndexNum;
    }
    else {
        return undefined;
    }
}
// TODO: Validate this rather than casting.
export function seatIndexParser(str) {
    return numberParser(str);
}
// TODO: Validate this rather than casting.
export function seatIndexesParser(str) {
    return numberArrayParser(str);
}
